import { render, staticRenderFns } from "./DoctorSpecialityModal.vue?vue&type=template&id=2adbe628&"
import script from "./DoctorSpecialityModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorSpecialityModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adbe628')) {
      api.createRecord('2adbe628', component.options)
    } else {
      api.reload('2adbe628', component.options)
    }
    module.hot.accept("./DoctorSpecialityModal.vue?vue&type=template&id=2adbe628&", function () {
      api.rerender('2adbe628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/DoctorSpecialityFilters/components/DoctorSpecialityModal.vue"
export default component.exports